<template>
  <div class="centent">
    <div class="titlefont" :class="{ nineShowRound: nineShowRound }">
      <div class="titleAnimation">
        <div class="title">关于我们</div>
        <div class="des">
          不用写代码，一样拿好工作。打造懂用户和精运营的新媒体、短视频及直播运营人才
        </div>
      </div>
    </div>

    <div class="cont">
      <div class="titlefont" :class="{ nineShowRound: nineShowRound }">
        <div class="titleAnimation">
          <div class="aboutInfo">
            <div class="item">
              <div class="tit"><span></span>学科亮点</div>
              <ul>
                <li>
                  本学科2020全年就业96.41%，均薪10634元
                </li>
                <li>学习周期短，就业速度快、就业率高</li>
                <li>
                  学费比同行少，薪资却高出1k~2k，性价比高
                </li>
              </ul>
            </div>
            <div class="line"></div>
            <div class="item">
              <div class="tit"><span class="drill"></span>学科实力</div>
              <ul>
                <li>
                  敢为人先，敢于公布班级平均就业率和班级平均薪资，就业率一直保持较高的记录 ，不放弃一名学生，数据远高过行业
                </li>
                <li>
                  老师均在企业一线有数年运营经验，项目经验丰富、行业人脉资源广阔
                </li>
                <li>
                  《数据分析思维与可视化》、《搜索引擎营销推广》等7套出版图书被广大高校引用授课。2688所普通高等院校中，有1622所使用传智播客出版的教材，约占高校总数的60.3%
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    nineShowRound: {
      type: Boolean,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    // 项目专栏点击前往详情页
    goDetails(url) {
      if (url) {
        let routeUrl = this.$router.resolve({
          path: url,
        });
        window.open(routeUrl.href, "_blank");
      }
    },
  },
};
</script>
<style src="./../style.scss" rel="stylesheet/scss" lang="scss" scoped></style>
<style lang="scss" scoped>
</style>
